import {
  IsNotEmpty,
  IsString,
  IsInt,
  IsUUID,
  Min,
  Max,
  MaxLength,
  IsOptional,
} from 'class-validator'
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { Type } from 'class-transformer'

export class CreateActivityCompetencyLinkDto {
  @ApiProperty({
    description: "UUID de l'activité",
    example: '550e8400-e29b-41d4-a716-446655440000',
  })
  @IsNotEmpty()
  @IsUUID('4')
  activityId!: string

  @ApiProperty({
    description: 'UUID de la compétence du programme',
    example: '660e8400-e29b-41d4-a716-446655440001',
  })
  @IsNotEmpty()
  @IsUUID('4')
  programCompetencyId!: string

  @ApiProperty({
    description: 'Niveau cible de la compétence',
    example: 'A2',
    maxLength: 32,
  })
  @IsNotEmpty()
  @IsString()
  @MaxLength(32)
  targetLevel!: string

  @ApiPropertyOptional({
    description: "Poids de la compétence dans l'activité (1-5)",
    example: 3,
    default: 3,
    minimum: 1,
    maximum: 5,
  })
  @IsOptional()
  @Type(() => Number)
  @IsInt()
  @Min(1)
  @Max(5)
  weight?: number
}
